import axios from 'axios';

// ── Base URL ────────────────────────────────────────────────────
// In development this hits localhost:5000
// On Railway/Render, set REACT_APP_API_URL in your frontend env
// const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
// const BASE_URL = process.env.REACT_APP_API_URL || 'https://ksp-reg.up.railway.app/api';
const BASE_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000, // 15 seconds
});

// ── Request interceptor — attach JWT automatically ───────────────
api.interceptors.request.use(
  (config) => {
    // Admin routes get the admin token, everything else gets the user token
    const isAdminRoute = config.url?.startsWith('/admin');
    const token = isAdminRoute
      ? localStorage.getItem('ks_admin_token')
      : localStorage.getItem('ks_token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ── Response interceptor — handle 401 globally ──────────────────
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || '';
    const isAdmin = requestUrl.startsWith('/admin') || requestUrl.includes('/auth/admin/');
    const isAuthRequest = requestUrl.startsWith('/auth/');

    // Token expired or invalid -> clear storage and redirect to login.
    // Login/signup failures are also 401s, so let those stay on the page.
    if (status === 401 && !isAuthRequest) {
      if (isAdmin) {
        localStorage.removeItem('ks_admin_token');
        window.location.href = '/admin';
      } else {
        localStorage.removeItem('ks_token');
        localStorage.removeItem('ks_user');
        window.location.href = '/login';
      }
    }

    // Pull the error message from the backend response
    const message =
      error.response?.data?.message ||
      error.message ||
      'Something went wrong';

    return Promise.reject(new Error(message));
  }
);

export default api;
